import Colors from '@/styles/_colors.module.scss'
import { createVuetify } from 'vuetify'
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n'
import * as directives from 'vuetify/directives'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { useI18n } from 'vue-i18n'
import { i18n } from './i18n'

const additionalComponents = { VDateInput }

export const vuetify = createVuetify({
  locale: {
    adapter: createVueI18nAdapter({ i18n, useI18n })
  },
  theme: {
    themes: {
      light: {
        colors: {
          primary: Colors.mainPrimary,
          accent: Colors.mainQuaternary,
          secondary: Colors.dark100,
          info: Colors.mainPrimary,
          warning: Colors.accentPrimary,
          error: Colors.accentError,
          success: Colors.accentSuccess,
          textPrimary: Colors.textPrimary,
          textAlternate: Colors.textAlternate
        }
      }
    }
  },
  components: additionalComponents,
  directives
})
